module.exports = __webpack_public_path__ + "static/img/cctLogo.ef5737d4.png";